export default __webpack_public_path__ + "static/media/lairs.05592b14.svg";